import { create } from 'zustand';

/**
 * Minimal wizard shell state. Server truth (draft version, event) lives in EventWizard and is synced here after saves.
 */
interface EventWizardState {
  eventId: string | null;
  draftVersion: number | null;
  stepIndex: number;
  /** Live title while creating/editing in the wizard (sidebar preview). */
  draftTitle: string;
  setEventId: (id: string | null) => void;
  setDraftVersion: (v: number | null) => void;
  setStepIndex: (i: number) => void;
  setDraftTitle: (title: string) => void;
  reset: () => void;
}

export const useEventWizardStore = create<EventWizardState>((set) => ({
  eventId: null,
  draftVersion: null,
  stepIndex: 0,
  draftTitle: '',
  setEventId: (id) => set({ eventId: id }),
  setDraftVersion: (v) => set({ draftVersion: v }),
  setStepIndex: (i) => set({ stepIndex: i }),
  setDraftTitle: (title) => set({ draftTitle: title }),
  reset: () => set({ eventId: null, draftVersion: null, stepIndex: 0, draftTitle: '' }),
}));
